'use client';

import { useEffect } from 'react';

import { useIsTattooPage } from './useIsTattooPage';

const TATTOO_CLASS = 'tattoo-page';
const PIERCING_CLASS = 'piercing-page';

export const useTattooBodyClass = () => {
  const isTattooPage = useIsTattooPage();

  useEffect(() => {
    if (typeof document !== 'undefined') {
      if (isTattooPage) {
        document.body.classList.add(TATTOO_CLASS);
        document.body.classList.remove(PIERCING_CLASS);
      } else {
        document.body.classList.remove(TATTOO_CLASS);
        document.body.classList.add(PIERCING_CLASS);
      }
    }

    return () => {
      if (typeof document !== 'undefined') {
        document.body.classList.remove(TATTOO_CLASS);
        document.body.classList.remove(PIERCING_CLASS);
      }
    };
  }, [isTattooPage]);
};
